import { Redirect, useParams } from "react-router-dom";
import { PageHeaderWithBack } from "../../../Components/Molecules";
import { ContaInternacionalDepositarContent } from "./components/ContaInternacionalDepositarContent";
import {
  CONTA_INTERNACIONAL_HOME_PATH,
  contaInternacionalCurrencyPath,
  getCurrency,
} from "./constants";

export const ContaInternacionalDepositar = () => {
  const { currencyId } = useParams();
  const currency = getCurrency(currencyId);

  if (!currency) {
    return <Redirect to={CONTA_INTERNACIONAL_HOME_PATH} />;
  }

  return (
    <div className="w-full">
      <PageHeaderWithBack
        title="Depositar"
        subTitle={`Informações bancárias para depositar em ${currency.label}.`}
        backTo={contaInternacionalCurrencyPath(currency.id)}
      />

      <div className="app-card p-4 sm:p-5">
        <ContaInternacionalDepositarContent isActive currencyId={currency.id} />
      </div>
    </div>
  );
};
